"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaSection = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mediaItem = require("./mediaItem");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MediaSection = props => {
  const {
    mediaSectionData,
    t,
    sectionType,
    mediaDescription
  } = props;
  const [itemsPerPage, setItemsPerPage] = (0, _react.useState)(3);
  const [startIndex, setStartIndex] = (0, _react.useState)(0);
  const [animating, setAnimating] = (0, _react.useState)(false);
  const [isMobile, setIsMobile] = (0, _react.useState)(window.innerWidth <= 800);
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  (0, _react.useEffect)(() => {
    if (!isMobile) {
      setItemsPerPage(3);
    }
  }, [isMobile, mediaSectionData.length]);
  const maxStartIndex = Math.max(mediaSectionData.length - itemsPerPage, 0);
  const handleSlide = dir => {
    if (animating) return;
    const newStartIndex = dir === "next" ? Math.min(startIndex + 1, maxStartIndex) : Math.max(startIndex - 1, 0);
    if (newStartIndex !== startIndex) {
      setAnimating(true);
      setTimeout(() => {
        setStartIndex(newStartIndex);
        setAnimating(false);
      }, 300);
    }
  };
  const getTranslateX = () => {
    return "translateX(-".concat(35 * startIndex, "%)");
  };
  const handleLoadMore = () => {
    const remainingItems = mediaSectionData.length - itemsPerPage;
    setItemsPerPage(prev => prev + Math.min(3, remainingItems));
  };
  const itemsToRender = isMobile ? mediaSectionData.slice(0, itemsPerPage) : mediaSectionData;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "media-page"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3"
  }, t("Pages.Media.".concat(sectionType))), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-subtitle__narrow con-text con-text__Xtra-larger-regular"
  }, mediaDescription || t("Pages.Media.MediaDescription"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-slider"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-items",
    style: {
      transform: getTranslateX()
    }
  }, itemsToRender.map((item, i) => /*#__PURE__*/_react.default.createElement("div", {
    className: "media-item-wrapper",
    key: i
  }, /*#__PURE__*/_react.default.createElement(_mediaItem.MediaItem, {
    sectionType: sectionType.toLowerCase(),
    mediaItemData: item
  }))))), mediaSectionData.length > 3 && isMobile && mediaSectionData.length - itemsPerPage > 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "media-load"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "con-text__large-medium con-text__button con-text__button--white media-load-btn",
    onClick: handleLoadMore
  }, "Load more")) : mediaSectionData.length > 3 && !isMobile && /*#__PURE__*/_react.default.createElement("div", {
    className: "media-pagination"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "media-arrow media-arrow--left",
    onClick: () => handleSlide("prev"),
    disabled: startIndex === 0,
    "aria-label": "previous-slide"
  }, "\u25B2"), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-dots"
  }, Array.from({
    length: maxStartIndex + 1
  }).map((_, i) => /*#__PURE__*/_react.default.createElement("span", {
    key: i,
    className: "media-dot ".concat(i === startIndex ? "media-dot--active" : ""),
    role: "button",
    "aria-label": "Go to slide ".concat(i + 1),
    onClick: () => {
      if (i !== startIndex && !animating) {
        setAnimating(true);
        setTimeout(() => {
          setStartIndex(i);
          setAnimating(false);
        }, 300);
      }
    }
  }))), /*#__PURE__*/_react.default.createElement("button", {
    className: "media-arrow media-arrow--right",
    onClick: () => handleSlide("next"),
    disabled: startIndex >= maxStartIndex,
    "aria-label": "next-slide"
  }, "\u25B2")));
};
exports.MediaSection = MediaSection;
MediaSection.propTypes = {
  mediaSectionData: _propTypes.default.array,
  t: _propTypes.default.func,
  sectionType: _propTypes.default.string,
  mediaDescription: _propTypes.default.string
};